<template>
  <div id="all-form">
    <h1>All Form</h1>

    <p>
      <router-link
        :to="{ name: 'CreateForm', params: { client_id: this.$route.params.id} }"
        class="btn btn-primary"
      >Create Form</router-link>
    </p>
   
    <div class="form-group">
      <input
        type="text"
        name="search"
        v-model="formSearch"
        placeholder="Search form"
        class="form-control"
        v-on:keyup="searchForms"
      />
    </div>

    <table class="table table-hover" style="width: 100%;">
      <thead>
        <tr>
          <td>Id</td>
          <td>Name</td>
          <td>Description</td>
          <td>Create Date</td>
          <td>Update Date</td>
          <td>Status</td>
          <td>Category</td>
          <td>Thumbnail</td>
          <td>Display Order</td>
          <td>Type</td>
          <td>Action Date</td>
          <td>Actions</td>
        </tr>
      </thead>

      <!-- <draggable v-model="list" tag="tbody"> -->
        <tr v-for="form in forms" :key="form.id">
          <td>{{ form.id }}</td>
          <td>{{ form.name_en }}</td>
          <td>{{ form.description_en }}</td>
          <td>{{ form.create_date }}</td>
          <td>{{ form.update_date }}</td>
          <td>{{ form.status }}</td>
          <td>{{ form.category }}</td>

          <td>
            <img :src="form.logo" width="50" height="50" />
          </td>
          <td>{{ form.display_order }}</td>
          <td>{{ form.form_type }}</td>
          <td>{{ form.action_date }}</td>
          <!-- <td>{{ form.date_updated }}</td>
          <td>{{ form.date_created }}</td>-->
          <td>
            <router-link
              :to="{name: 'EditForm', params: { id: form.id }}"
              class="btn btn-primary"
            >Edit</router-link>
            <router-link
              :to="{name: 'DeleteForm', params: { id: form.id }}"
              class="btn btn-danger"
            >Delete</router-link>
            <router-link
              :to="{name: 'BuildForm', params: { id: form.id }}"
              class="btn btn-danger"
            >Build Form</router-link>
          </td>
        </tr>
      <!-- </draggable> -->
    </table>
  </div>
</template>

<script>
// import Punny from './Punny';
import draggable from "vuedraggable";
import axios from "axios";
import { BACKEND_URL } from '../../variables';
export default {
  components: {
    draggable,
  },
  data() {
    return {
      forms: [],
      originalForms: [],
      formSearch: "",
      dragging: false,
    };
  },
  mounted: function () {
    this.fetchFormData();
  },
  methods: {
    fetchFormData: function () {

      axios
        .get(BACKEND_URL+"form?client_id=" +this.$route.params.client_id )

       
        .then(
          (response) => {
            this.forms = response.data;
            this.originalForms = this.forms;
            if(this.forms){for (var i = 0; i < this.forms.length; i++) {
              this.forms[i].date_updated = new Date(
                this.forms[i].date_updated
              ).toString();
              this.forms[i].create_date = new Date(
                this.forms[i].create_date
              ).toString();
            }}
          },
          (response) => {}
        );
    },
    searchForms: function () {
      if (this.formSearch == "") {
        this.forms = this.originalForms;
        return;
      }
      var searchedForms = [];
      for (var i = 0; i < this.originalForms.length; i++) {
        var formTitle = this.originalForms[i]["name_en"].toLowerCase();
        if (formTitle.indexOf(this.formSearch.toLowerCase()) >= 0) {
          searchedForms.push(this.originalForms[i]);
        }
      }
      this.forms = searchedForms;
    },
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
h1,
h2 {
  font-weight: normal;
}
ul {
  list-style-type: none;
  padding: 0;
}
li {
  display: inline-block;
  margin: 0 10px;
}
a {
  /*color: #42b983;*/
}
#all-form {
  /*width: 400px;*/
  /*margin: 20px 20px 40px 40px;*/
  /*background-color: #66ffff;*/
  /*margin-top: 100px;
    margin-bottom: 100px;
    margin-right: 80px;
    margin-left: 80px;*/
}
</style>



// WEBPACK FOOTER //
// all-form.vue?f74a3b3a